<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col text-right">
          <base-button
            block
            type="default"
            size="sm"
            class="mb-3"
            @click="modals.modal3 = true"
          >
            Añadir peso
          </base-button>

          <modal
            :show.sync="modals.modal3"
            body-classes="p-0"
            modal-classes="modal-dialog-centered modal-sm"
          >
            <card
              type="secondary"
              shadow
              header-classes="bg-white pb-5"
              body-classes="px-lg-5 py-lg-5"
              class="border-0"
            >
              <template>
                <div class="text-muted text-center mb-3">
                  <h2>Añadir peso</h2>
                  <label for="">Añadir peso y fecha de registro:</label>
                </div>
              </template>

              <template>
                <form role="form" @submit.prevent="createPeso">
                  <base-input
                    alternative
                    class="mb-3"
                    placeholder="Peso"
                    addon-left-icon="ni ni-album-2"
                    type="number"
                    step=".01"
                    v-model="addPeso.peso"
                  >
                  </base-input>
                  <small v-if="peso_null" style="color:red;">Debe introducir el peso</small>
                  <div class="align-content-initial">
                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{ allowInput: true, dateFormat: 'd-m-Y H:i' }"
                        class="form-control datepicker"
                        v-model="addPeso.fecha"
                      >
                      </flat-picker>
                    </base-input>
                  </div>
                  <div class="text-center">
                    <button class="btn btn-primary btn-block save">
                      Añadir
                    </button>
                  </div>
                </form>
              </template>
            </card>
          </modal>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="tableData"
      >
        <template slot="columns">
          <th></th>
          <th>Fecha</th>
          <th>Peso</th>
        </template>

        <template slot-scope="{ row }">
          <td class="text-left">
            <base-dropdown class="dropdown por-arriba" position="left">
              <a
                slot="title"
                class="btn btn-sm btn-icon-only text-light"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <base-button
                  block
                  class="dropdown-item"
                  @click="getPeso(row.id)"
                >
                  <span>Editar</span>
                </base-button>

                <base-button
                  block
                  class="dropdown-item"
                  @click="deletePeso(row.id)"
                >
                  <span>Eliminar</span>
                </base-button>
              </template>
            </base-dropdown>
          </td>
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm"
                  ><span>{{ row.fecha }}</span></span
                >
              </div>
            </div>
          </th>
          <td class="budget">{{ row.peso }} Kg</td>
        </template>
      </base-table>
    </div>

    <modal
      :show.sync="modals.modal1"
      body-classes="p-0"
      modal-classes="modal-dialog-centered modal-sm"
    >
      <card
        type="secondary"
        shadow
        header-classes="bg-white pb-5"
        body-classes="px-lg-5 py-lg-5"
        class="border-0"
      >
        <template>
          <div class="text-muted text-center mb-3">
            <h2>Editar peso</h2>
            <label for="">Modificar el peso y fecha del registro: {{ modifPeso.peso}}</label>
          </div>
        </template>

        <template>
          <form role="form" @submit.prevent="editPeso">
            <base-input
              alternative
              class="mb-3"
              placeholder="Peso"
              addon-left-icon="ni ni-album-2"
              type="number"
              step=".01"
              v-model="modifPeso.peso"
            >
            </base-input>
            <div class="align-content-initial">
              <base-input addon-left-icon="ni ni-calendar-grid-58">
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true, dateFormat: 'd-m-Y H:i' }"
                  class="form-control datepicker"
                  v-model="modifPeso.fecha"
                >
                </flat-picker>
              </base-input>
            </div>
            <div class="text-center">
              <button class="btn btn-primary btn-block save">Guardar</button>
            </div>
          </form>
        </template>
      </card>
    </modal>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
    <button class="page-item page-link" :disabled="pagination.validated" @click="siguiente">Mostrar más</button>
    <button class="page-item page-link" :disabled="pagination.validated" @click="mostrarTodos">Mostrar todos</button>
    </div>
  </div>
</template>
<script>
import { db } from "../../firebaseDb";
import { auth } from "../../firebaseDb";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  components: { flatPicker },
  name: "pesos-table",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      user: auth.currentUser,
      tableData: [],
      addPeso: {
        peso: 0,
        fecha: new Date(),
      },
      modifPeso: {
        peso: 0,
        fecha: "",
        id: ""
      },
      modals: {
        modal1: false,
        modal3: false,
      },
      last: null,
      pagination: {
        default: 1,
        total: 0,
        paginas: 0,
        porPagina: 4,
        validated: false
      },
      peso_null: false,
    };
  },
  created: function () {
    this.creado();
  },
  methods: {
    creado(){
      db.collection('users').doc(this.user.uid).collection('pesos').get()
    .then(snapshot => {
        this.pagination.total = snapshot.size;
        this.pagination.paginas = Math.ceil(this.pagination.total / this.pagination.porPagina); 
    });
    db.collection("users")
      .doc(this.user.uid)
      .collection("pesos")
      .limit(this.pagination.porPagina)
      .orderBy("fecha", "desc")
      .onSnapshot({ includeMetadataChanges: true }, (snapshot) => {
        this.last = snapshot.docs[snapshot.docs.length - 1];
        this.tableData = [];
        snapshot.forEach((doc) => {
          let item = doc.data();
          item.id = doc.id;

          item.fecha = item.fecha.toDate().toLocaleDateString("es-ES");

          this.tableData.push(item);
        });
      });
    },
    siguiente(){
      db.collection("users").doc(this.user.uid).collection("pesos")
        .limit(this.pagination.porPagina)
        .orderBy("fecha", "desc")
        .startAfter(this.last)
        .get()
        .then((snapshot) => {
          this.last = snapshot.docs[snapshot.docs.length - 1];
          snapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;

            item.fecha = item.fecha.toDate().toLocaleDateString("es-ES");

            this.tableData.push(item);
          });
          try {
            db.collection("users").doc(this.user.uid).collection("pesos")
              .limit(this.pagination.porPagina)
              .orderBy("fecha", "desc")
              .startAfter(this.last)
              .get();
          } catch (error) {
            console.error(error);
            this.pagination.validated = true;
          }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    mostrarTodos(){
      db.collection("users").doc(this.user.uid).collection("pesos")
        .orderBy("fecha", "desc")
        .startAfter(this.last)
        .get()
        .then((snapshot) => {
          this.last = snapshot.docs[snapshot.docs.length - 1];
          snapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;

            item.fecha = item.fecha.toDate().toLocaleDateString("es-ES");

            this.tableData.push(item);
          });
        })
        .catch((error) => {
            console.error(error);
        });
    },
    deletePeso(id) {
      if (window.confirm("¿Está seguro de eliminar este registro de peso?")) {
        this.track_delete();
        db.collection("users")
          .doc(this.user.uid)
          .collection("pesos")
          .doc(id)
          .delete()
          .then(() => {
            console.log("Document deleted!");
            this.tableData = [];
            this.creado();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    createPeso(event) {
      event.preventDefault();
      if (this.addPeso.peso == '' || this.addPeso.peso == null || this.addPeso.peso == 0) {
        this.peso_null = true;
      }else{
        this.peso_null = false;
        try {
          this.addPeso.fecha = this.addPeso.fecha.substring(6,10)+'-'+this.addPeso.fecha.substring(3,5)+'-'+this.addPeso.fecha.substring(0,2)+' '+this.addPeso.fecha.substring(11,16);
        } catch (error) {
          console.log(error);
        }
        this.track();
        db.collection("users")
          .doc(this.user.uid)
          .collection("pesos")
          .add({
            peso: this.addPeso.peso,
            fecha: new Date(this.addPeso.fecha),
          })
          .then(() => {
            this.addPeso.peso = "";
            this.addPeso.fecha = new Date();
            this.tableData = [];
            this.creado();
            this.modals.modal3 = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    },
    editPeso(event) {
      event.preventDefault();
      this.modifPeso.fecha = this.modifPeso.fecha.substring(6,10)+'-'+this.modifPeso.fecha.substring(3,5)+'-'+this.modifPeso.fecha.substring(0,2)+' '+this.modifPeso.fecha.substring(11,16)
      this.track_edit();
      db.collection("users")
        .doc(this.user.uid)
        .collection("pesos")
        .doc(this.modifPeso.id)
        .update({
          peso: this.modifPeso.peso,
          fecha: new Date(this.modifPeso.fecha),
        })
        .then(() => {
          this.modifPeso.peso = "";
          this.modifPeso.fecha = "";
          this.tableData = [];
          this.creado();
          this.modals.modal1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPeso(id){
        var self = this
        db.collection("users")
        .doc(this.user.uid)
        .collection("pesos")
        .doc(id)
        .get()
        .then(function(snapshot) {
            if(snapshot.exists){
                try {
                    self.modifPeso.peso = snapshot.data().peso
                    let fecha_recuperada = snapshot.data().fecha.toDate()
                    self.modifPeso.fecha = fecha_recuperada
                    self.modifPeso.id = snapshot.id
                    self.modals.modal1 = true;
                } catch (error) {
                    console.log(error)
                }
            }else{
                console.log("El peso no se ha encontrado")
            }
        });
    },
    track() {
      this.$gtag.event("added_weigth", {
        'event_category': "weigth",
        'event_label': "weigth_added",
        'value': 1
      })
    },
    track_edit() {
      this.$gtag.event("edited_weigth", {
        'event_category': "weigth",
        'event_label': "weigth_edited",
        'value': 1
      })
    },
    track_delete() {
      this.$gtag.event("deleted_weigth", {
        'event_category': "weigth",
        'event_label': "weigth_deleted",
        'value': 1
      })
    },
  },
};
</script>
<style>
.por-arriba {
  position: absolute;
}
.page-item{
  margin: 2px;
}
</style>
